import type { DailyWeatherSnapshot, EconomicArticle } from '../domain/models';

export interface TodayContentPayload {
  contentDate: string;
  region: string;
  weather: DailyWeatherSnapshot;
  articleId?: string;
  article?: EconomicArticle;
  weatherSourceMode?: 'live' | 'server-fallback';
  /** 'package' means a published content package owns this date. */
  articleSourceMode?: 'live' | 'database' | 'package';
  packageId?: string;
  packageVersion?: number;
  sourceMode: 'live' | 'server-fallback';
  refreshedAt: string;
}

function isPayload(value: unknown): value is TodayContentPayload {
  if (!value || typeof value !== 'object') return false;
  const candidate=value as Partial<TodayContentPayload>;
  return typeof candidate.contentDate==='string'
    && typeof candidate.region==='string'
    && typeof candidate.sourceMode==='string'
    && Boolean(candidate.weather && typeof candidate.weather==='object');
}

export async function fetchTodayContent(region: string, signal?: AbortSignal): Promise<TodayContentPayload> {
  const query=new URLSearchParams({ region });
  const response=await fetch(`/api/today-content?${query.toString()}`, { headers:{ Accept:'application/json' }, signal });
  if (!response.ok) throw new Error(`TODAY_CONTENT_${response.status}`);
  const payload:unknown=await response.json();
  if (!isPayload(payload)) throw new Error('TODAY_CONTENT_INVALID');
  return payload;
}
